/* eslint-disable require-jsdoc */
import { useEffect, useState, startTransition } from "react"
import useIsSsr from "@/hooks/useIsSsr"

const useWindowResize = ({ debounceMs = 0 } = {}) => {
  const isSsr = useIsSsr()
  const [size, setSize] = useState([0, 0])

  useEffect(() => {
    if (isSsr) {
      return
    }

    let timeoutId = null
    const apply = () => {
      startTransition(() => {
        setSize([window.innerWidth, window.innerHeight])
      })
    }

    function updateSize() {
      // Default (debounceMs = 0) keeps the original per-event behavior.
      // When opted in, subsequent resize events are debounced (trailing) so
      // width-derived consumers don't re-render on every resize tick.
      if (!debounceMs) {
        apply()
        return
      }
      if (timeoutId) clearTimeout(timeoutId)
      timeoutId = setTimeout(apply, debounceMs)
    }

    window.addEventListener("resize", updateSize)
    apply() // leading: measure immediately on mount so initial sizing is correct

    return () => {
      window.removeEventListener("resize", updateSize)
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [isSsr, debounceMs])

  return size
}

export default useWindowResize
